export interface PathologyTO {
  id: string;
  name: string;
}

export const toPathologyTO = (
  pathology: string,
  index: number,
): PathologyTO => ({
  id: `pathology-${index}-${pathology.toLocaleLowerCase().slice(0, 5).trim()}`,
  name: pathology,
});
